import type { CitationNodeProps } from "@op/richtext-types";
import {
  Dc_Text_Citation,
  Dc_Text_Citation_Trigger_Unsynced,
  Dc_Text_Citation_Trigger_Mobile,
} from "@op/sf-op";
import { useLayerCitations } from "@op/utils";
import { useEffect, useMemo, useState } from "react";
import { CitationSourceLink } from "../../../../../components/base/CitationSourceLink";
import { makeCitationId } from "@op/utils";

const CitationNode = ({ id, attrs }: CitationNodeProps) => {
  const citations = useLayerCitations();

  const [isTouch, setIsTouch] = useState<boolean>(false);

  function onResize() {
    setIsTouch(window.matchMedia("(pointer: coarse)").matches);
  }

  useEffect(() => {
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, ["run-once"]);

  const TriggerComponent = useMemo(
    () =>
      isTouch
        ? Dc_Text_Citation_Trigger_Mobile
        : Dc_Text_Citation_Trigger_Unsynced,
    [isTouch],
  );

  const citation = useMemo(() => {
    return citations.find((citation) => citation.uniqueId === attrs.uniqueId);
  }, [citations, attrs.uniqueId]);

  if (!citation) return null;
  return (
    <TriggerComponent
      citationIndex={`[${citation.index}]`}
      className={makeCitationId(citation.index)}
      id={id}
    >
      <Dc_Text_Citation linkSlot={<CitationSourceLink citation={citation} />}>
        <Dc_Text_Citation.Text>{citation.content}</Dc_Text_Citation.Text>
      </Dc_Text_Citation>
    </TriggerComponent>
  );
};

export default CitationNode;
